<div class="flex flex-column h-full overflow-hidden">
    <div>
        <app-toolbar></app-toolbar>
    </div>
    <platform-dev-mode-banner></platform-dev-mode-banner>
    <div class="flex-1 flex overflow-hidden">
        <app-main-sidenav
            [activePageMenu]="{
                activeMenuCategory: 0,
                activeCategoryItem: indexNumber,
            }"
            [categorizedPages]="categorizedPages"
            (pageEmitter)="pageEmit($event)"
        ></app-main-sidenav>
        <div class="flex-1 flex flex-column surface-50 overflow-hidden">
            @if (showMenuComponent) {
                <app-bread-crumb class="h-3rem" [items]="items"></app-bread-crumb>
            }
            <div class="flex-1 flex flex-column radius-md p-3 overflow-auto">
                <router-outlet></router-outlet>
            </div>
            <app-footer></app-footer>
        </div>
    </div>
</div>
